<template>
  <div id="print-1046">
    <div class="a4" style="padding: 80px;">
      <div style="padding: 20px">
        <div class="head-label" style="text-align: center;">-「중대재해처벌법」시민재해분야-</div>
        <div class="head-title" style="text-align: center;">'(년도 Data)년 (시설물명 Data)시설 안전 계획*</div>
      </div>

      <table style="margin-top: 20px;">
        <tr>
          <th style="border: 1px solid #cdcdcd; padding: 10px 15px;">
            <p class="content-normal">
              ｢중대재해처벌 등에 관한 법률｣ 및 ｢00000에 관한 법률(시설소관법령기재)｣ ○○○시설의 산업안전보건대책을 마련하여 중대 시민재해 예방에 선제적으로 대응하고자 함
            </p>
          </th>
        </tr>
      </table>
      <p class="content-small" style="padding: 20px 0;">* 시설물안전법에 의한 작성대상 시설물은 안전 및 유지관리계획으로 작성 가능함</p>

      <!-- 관련근거 -->
      <section-component label="관련근거" index="1" style="margin: 16px 0;" />
      <span class="content-normal" style="padding: 10px 0;" v-html="form.관련근거"/>

    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 현황(시설물, 예산 등) -->
      <section-component label="현황(시설물, 예산 등)" index="2" style="margin: 16px 0;" />
      <!-- 1. 시설물 및 안전사고 발생 현황-->
      <div class="flex gap-4 head-subtitle">
        <span>1. 시설물 및 안전사고 발생 현황</span>
        <span style="color: #4839EB; font-weight: 500;">※시설물 특성에 따라 작성, 서식변경 가능</span>
      </div>
      <p class="content-normal" style="margin: 10px 24px;" v-html="form.안전관리대상시설현황"/>

      <p class="caption-top" style="text-align: center;">< 안전관리 대상 시설 현황 ></p>
      <table style="margin-top: 10px;">
        <colgroup>
          <col /><col /><col />
          <col width="25%" />
          <col /><col />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">관리주체</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분유형</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">사용용도</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구조, 층수</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">연면적(㎡)</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr v-for="(item, index) in form.안전관리대상시설현황리스트" :key="`안전관리대상시설현황리스트_${index}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.관리주체 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분유형 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.사용용도 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구조 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.연면적 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
      </table>

      <p class="content-normal" style="margin-top: 32px; margin-left: 24px; margin-right: 24px;" v-html="form.안전사고발생현황"/>

      <p class="caption-top" style="text-align: center; margin: 10px 0;">< 연도별 안전사고 발생현황 (최근 3년) ></p>
      <p class="caption-top" style="text-align: end;">(단위 : 건, 명) ※ 괄호 부분은 직원사고</p>
      <table style="margin-top: 10px;">
        <tbody>
          <tr>
            <th colspan="2"  style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
            <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">평균</th>
            <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">{{ form.안전사고발생년도 }}</th>
            <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">{{ form.안전사고발생년도 + 1 }}</th>
            <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">{{ form.안전사고발생년도 + 2 }}</th>
          </tr>
          <tr v-for="(item, itemIndex) in form.안전사고발생현황리스트" :key="`안전사고발생현황리스트_${itemIndex}`">
            <th v-if="itemIndex === 0" rowspan="3" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">인명피해</th>
            <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">{{ item.구분 }}</th>
            <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">
              {{ (item.년도별.reduce((sum, value) => sum + Number(value), 0) / item.년도별.length).toFixed(2) }}</td>
            <td v-for="(year, yearIndex) in item.년도별" :key="`year_${yearIndex}`"
                style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ year }}</td>
          </tr>
        </tbody>
      </table>

      <p class="content-normal" style="margin-top: 32px; margin-left: 24px; margin-right: 24px;" v-html="form.안전등급및점검결과" />
      <table style="margin-top: 10px;">
        <colgroup>
          <col width="152" />
          <col width="248" />
          <col width="248" />
          <col width="380" />
        </colgroup>
        <tbody>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">시설물분류</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">점검결과</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">조치결과</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.안전등급및점검결과리스트" :key="`안전등급및점검결과리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.시설물분류 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.점검결과 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.조치결과 }}</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 2. 안전 예산현황 -->
      <p class="head-subtitle" style="margin-top: 10px;">2. 안전 예산현황</p>
      <p class="content-normal" style="margin: 10px 24px;">❍ 안전계획이행, 시민재해 관리 업무 처리 이행, 안전보건관계 법령상 의무이행 비용 예산 등</p>

      <p class="mt-4 caption-top" style="text-align: end;">(단위 : 천원)</p>
      <table v-if="!form.is총예산입력">
        <colgroup>
          <col width="64" />
          <col width="164" />
          <col width="437" />
          <col width="180" />
          <col width="180" />
        </colgroup>
        <tbody>
        <tr>
          <th colspan="3" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분(포함항목)</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">편성액</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr>
          <td colspan="3" style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">계</td>
          <td style="border: solid #cdcdcd 1px; text-align: end; padding: 10px;">{{ 안전예산편성액_계 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ form.안전예산현황리스트_비고 }}</td>
        </tr>
        <tr v-for="(item, itemIndex) in form.안전예산현황리스트" :key="`안전예산현황리스트_${itemIndex}`">
          <td v-if="itemIndex === 0" rowspan="5" style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">안전예산</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.title }} </td>
          <td style="border: solid #cdcdcd 1px; text-align: start; padding: 10px;">{{ item.content }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: end; padding: 10px;">{{ comma(item.편성액) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
        </tbody>
      </table>
      <table v-else>
        <colgroup>
          <col width="665" />
          <col width="180" />
          <col width="180" />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분(포함항목)</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">편성액</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">총예산</td>
          <td style="border: solid #cdcdcd 1px; text-align: end; padding: 10px;">{{ comma(form.안전예산현황_총예산.편성액) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ form.안전예산현황_총예산.비고 }}</td>
        </tr>
      </table>

      <!-- 3. 안전 인력 및 조직 현황 -->
      <p class="head-subtitle" style="margin-top: 32px;">3. 안전 인력 및 조직 현황</p>
      <p class="content-normal" style="padding: 10px 24px;">❍ 인력현황</p>
      <table>
        <colgroup>
          <col width="116" />
          <col width="230" />
          <col width="94" />
          <col width="94" />
          <col width="94" />
          <col width="94" />
          <col width="94" />
          <col width="94" />
          <col width="116" />
        </colgroup>
        <thead>
        <tr>
          <th rowspan="3" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
          <th rowspan="3" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">해당업무</th>
          <th colspan="6" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">인력현황</th>
          <th rowspan="3" style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">계</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">공무원</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">공무직</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">기간제</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">보건관리자</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">기타</th>
        </tr>
        <tr>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.계 || 0), 0) ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.공무원 || 0), 0) ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.공무직 || 0), 0) ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.기간제 || 0), 0) ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.보건관리자 || 0), 0) ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( form.인력현황리스트.reduce((sum, item) => sum + Number(item.기타 || 0), 0) ) }}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, itemIndex) in form.인력현황리스트" :key="`인력현황리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.해당업무 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( item.계 ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma(item.공무원) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma(item.공무직) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( item.기간제 ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( item.보건관리자 ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ comma( item.기타 ) }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
        </tbody>
      </table>
      <p class="caption-top" style="text-align: start; margin-top: 10px; padding: 0 24px;">※ 안전조치 업무: 긴급안전조치, 공중이용시설 사용제한·사용금지·해체, 용도제한, 위험표지의 설치 등의 업무</p>
      <p class="caption-top" style="text-align: start; padding: 0 24px;">※ 중대재해법 의무사항 이행을 위한 필요인력, 개별법 등 에서 규정하는 인력을 포함하여 작성</p>
    </div>

    <div class="a4" style="padding: 80px;">
      <div class="flex gap-4 content-normal" style="padding: 0 24px;">
        <span>❍ 안전보건관리 조직도</span>
        <span>※ 필요시 작성, 안전인력에 대한 조직도</span>
      </div>
      <div style="margin-top: 10px; padding: 0 48px;">
        <table>
          <tr>
            <th style="border: solid #cdcdcd 1px; padding: 10px;">
              <p style="font-weight: 400; font-size: 20px; text-align: start;">
                ▶ 작성방법<br/>
                - 각 시설별 안전보건관리 책임자를 확인하여 작성<br/>
                - 시설 별 업무분장에 따라 수정하여 작성 가능<br/>
                - 위탁시설의 경우 수탁업체 현황 포함하여 작성 가능
              </p>
            </th>
          </tr>
        </table>
      </div>

      <p v-if="tableData1.length > 0" class="content-normal" style="text-align: start; font-weight: 500; margin: 10px 48px;">&lt;직영&gt;</p>
      <div class="print-body">
        <print-node v-for="data of tableData1" :value="data"/>
      </div>
    </div>

    <div v-if="tableData2.length > 0" class="a4" style="padding: 80px;">
      <p class="mt-4 content-normal" style="text-align: start; font-weight: 500;
       margin-top: 10px; margin-left: 48px; margin-right: 48px;">&lt;위탁&gt;</p>
      <div class="print-body">
        <print-node v-for="data of tableData2" :value="data"/>
      </div>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 세부추진 계획 -->
      <section-component label="세부추진 계획" index="3" style="margin: 16px 0;" />
      <!-- 1. 안전점검 계획 -->
      <p class="flex gap-4 head-subtitle">1. 안전점검 계획</p>
      <p class="head-subtitle" style="margin: 10px 12px;">□ 근거 규정</p>
      <p class="content-normal" style="padding: 0 24px;" v-html="form.근거규정"/>
      <div style="margin-top: 10px; padding: 0 48px;">
        <table>
          <tr>
            <th style="border: solid #cdcdcd 1px; padding: 10px;">
              <p style="font-weight: 400; font-size: 20px; text-align: start;">
                ▶ 작성방법<br/>
                - 시설물 안전법 포함 소관 시설물과 관련된 모든 관계법령에 대한 당해연도 점검계획수립<br/>
                - 위탁하여 관리하고 있는 분야가 있을 경우 위탁관리 점검 관리계획 작성<br/>
                ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
              </p>
            </th>
          </tr>
        </table>
      </div>

      <p class="head-subtitle" style="margin: 10px 12px;">□ 점검 계획</p>
      <table style="margin-top: 10px;">
        <colgroup>
          <col width="144" />
          <col width="144" />
          <col width="144" />
          <col width="320" />
          <col width="64" />
          <col width="90" />
          <col width="120" />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">세부구분</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">점검주기</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">내용</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">실시방법</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">예산액(백만원)</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.점검계획리스트" :key="`점검계획리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.세부구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.점검주기 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.내용 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.실시방법 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.예산액 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
      </table>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 분야별 중점 점검사항 -->
      <p class="head-subtitle">□ 분야별 중점 점검사항</p>
      <table style="margin-top: 10px;">
        <colgroup>
          <col width="210" />
          <col width="696" />
          <col width="120" />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">점검 내용</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.분야별중점점검사항리스트" :key="`분야별중점점검사항리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.점검내용 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
      </table>

      <table style="margin-top: 40px;">
        <tr>
          <th style="border: 1px dashed #cdcdcd; padding: 10px 15px;">
            <p style="content-normal" v-html="form.분야별중점점검사항" />
          </th>
        </tr>
      </table>
      <p style="text-align: start; margin: 14px 24px; font-weight: 400; font-size: 24px;">
        ※ 원료·제조물: 시행령 제9조제2항1호에 따라 안전·보건 관계 법령에 따른 의무 이행은 반기 1회 이상 점검</p>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 점검결과 따른 조치계획 -->
      <p class="head-subtitle">□ 점검결과 따른 조치계획</p>
      <p class="content-normal" style="margin: 10px 24px;" v-html="form.점검결과따른조치계획"/>

      <!-- 2. 유지관리 계획 -->
      <p class="head-subtitle" style="margin-top: 32px;">2. 유지관리 계획</p>
      <table style="margin-top: 10px;">
        <tr>
          <th style="border: solid #cdcdcd 1px; padding: 10px;">
            <p style="font-weight: 400; font-size: 20px; text-align: start;">
              ▶ 작성방법<br/>
              - 당해연도 시행 할 주요 보수·보강 계획 작성<br/>
              - 정기점검 및 수시점검 계획에 따른 유지관리계획 작성<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
            </p>
          </th>
        </tr>
      </table>

      <table style="margin-top: 32px;">
        <colgroup>
          <col width="170" />
          <col width="170" />
          <col width="170" />
          <col width="107" />
          <col width="90" />
          <col width="320" />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">구분</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">대상</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">점검시기</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">시행방법</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">예산액<br/>(백만원)</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">보강·보수내용</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.유지관리계획리스트" :key="`유지관리계획리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.구분 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.대상 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.점검시기 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.시행방법 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.예산액 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.보강보수내용 }}</td>
        </tr>
      </table>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- 3. 관련법령에 따른 의무사항 이행계획 -->
      <p class="head-subtitle">3. 관련법령에 따른 의무사항 이행계획</p>
      <p class="content-normal" style="margin: 10px 24px;">❍ 관련법령에 따른 의무사항 이행(시행령 제11조 제2항)</p>
      <table>
        <tr>
          <th style="border: solid #cdcdcd 1px; padding: 10px;">
            <p style="font-weight: 400; font-size: 20px; text-align: start;">
              ▶ 작성방법<br/>
              - 소관 시설물과 관련된 모든 관계법령에 대한 의무사항을 기재<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
            </p>
          </th>
        </tr>
      </table>

      <table style="margin-top: 32px;">
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">관련법령</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">의무사항</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">이행계획</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.관련법령에따른의무사항이행계획리스트" :key="`관련법령에따른의무사항이행계획리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.관련법령 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.의무사항 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.이행계획 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
      </table>

      <p class="content-normal" style="margin-top: 10px; color: #4839EB; font-weight: 500; font-size: 24px;">
        ※ 시설별 관리법령에 따른 의무사항 전수조사 및 기재</p>
      <p class="content-normal" style="margin: 10px 24px;">❍ 안전·보건 관계법령의 기준</p>
      <p class="content-normal" style="margin: 0 48px;">
        → 안전·보건 관계 법령은 해당 공중이용시설에 적용되는 것으로서 이용자나 그 밖의 사람의 안전·보건을 확보하는 데 관련되는 법령을 말함
      </p>

      <table>
        <tr>
          <th style="border: 1px dashed #cdcdcd; padding: 10px 15px;">
            <p style="font-weight: 500; font-size: 24px;">▶ 구제적으로</p>
            <p style="font-weight: 400; font-size: 20px; text-align: start; margin-top: 10px;">
              ❶ 공중이용시설 또는 공중교통수단의 안전 확보를 목적으로 하는 법률<br/>
              ❷ 대상을 이용하는 국민의 안전을 위해 의무를 부과하는 법률<br/>
              ❸ 공중이용시설 및 공중교통수단을 구성하는 구조체, 시설, 설비, 부품 등의 안전에 대하여 안전점검, 보수·보강 등을 규정하는 법률<br/>
              ❹ 이용자의 안전을 위해 관리자, 종사자가 관련 교육을 이수토록 규정하는 법률 등을 안전·보건 관계법령으로 보고자 함
            </p>
          </th>
        </tr>
      </table>

      <table style="margin-top: 32px;">
        <tr>
          <th style="border: 1px dashed #cdcdcd; padding: 10px 15px;">
            <p style="font-weight: 500; font-size: 24px;">▶ 안전·보건 관계법령의 예시</p>
            <p style="font-weight: 400; font-size: 20px; text-align: start; margin-top: 10px;">
              ❶ 도로교량, 터널: 시설물안전법<br/>
              ❷ 건축물: 시설물안전법, 건축물관리법, 초고층재난관리법<br/>
              ※ 초고층재난관리법은 층수가 50층 이상 또는 높이가 200m 이상인 건축물 등에 적용<br/>
              ❸ 하천시설(하구둑, 제방 보): 시설물안전법, 하천법<br/>
              ❹ 상하수도시설: 시설물안전법, 수도법, 하수도법<br/>
              ❺ 옹벽 및 전토사면: 시설물안전법<br/>
              ❻ 국공립어린이집: 영유아법, 실내공기질법, 기타등등
            </p>
          </th>
        </tr>
      </table>
    </div>

    <div class="a4" style="padding: 80px;">
      <!-- ❍ 안전관리자 등 교육이수 계획(시행령 제11조 제2항 3호) -->
      <p class="content-normal" style="margin: 0 24px;">❍ 안전관리자 등 교육이수 계획(시행령 제11조 제2항 3호)</p>
      <table style="margin-top: 10px;">
        <tr>
          <th style="border: solid #cdcdcd 1px; padding: 10px;">
            <p style="font-weight: 400; font-size: 20px; text-align: start;">
              ▶ 작성방법<br/>
              - 소관 시설물과 관련된 모든 교육대상자의 교육이수 계획 수립<br/>
              ※ 아래사항은 세부추진계획 작성을 위한 형식, 대상 법령 등을 기재하였으므로 필요사항을 참고하여 작성조치
            </p>
          </th>
        </tr>
      </table>

      <p style="margin-top: 10px; padding: 0 48px; font-weight: 400; font-size: 24px;">- (교육대상) {{ form.교육대상 }}</p>
      <p style="padding: 0 48px; font-weight: 400; font-size: 24px;">- (이수점검) {{ form.이수점검 }}</p>
      <table style="margin-top: 10px;">
        <colgroup>
          <col width="169" />
          <col width="260" />
          <col width="169" />
          <col width="260" />
          <col width="169" />
        </colgroup>
        <tr>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">교육대상</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">교육과정</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">교육시간</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">교육방법</th>
          <th style="border: solid #cdcdcd 1px; text-align: center; background: #FFF7E2; padding: 10px;">비고</th>
        </tr>
        <tr v-for="(item, itemIndex) in form.교육이수계획리스트" :key="`교육이수계획리스트_${itemIndex}`">
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.교육대상 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.교육과정 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.교육시간 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.교육방법 }}</td>
          <td style="border: solid #cdcdcd 1px; text-align: center; padding: 10px;">{{ item.비고 }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import SectionComponent from "@/views/boards/single-page/1046/SectionComponent.vue";
import NumberInput from "@/components/NumberInput.vue";
import PrintNode from "@/views/boards/single-page/1046/PrintNode.vue";

export default {
  components: {PrintNode, NumberInput, SectionComponent},
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    안전예산편성액_계() {
      const result = this.form.안전예산현황리스트.reduce((sum, item) => sum + Number(item.편성액), 0);
      return this.comma(result)
    },
    tableData1 () {
      const list = []; //this.form.data
      if (this.form && this.form.organogram1 && this.form.organogram1.data) {
        for (const item of this.form.organogram1.data) {
          this.convertTreeToTable(1, item, 1)
        }
        list.push(...this.form.organogram1.data)
      }
      return list
    },
    tableData2 () {
      const list = []; //this.form.data
      if (this.form && this.form.organogram2 && this.form.organogram2.data) {
        for (const item of this.form.organogram2.data) {
          this.convertTreeToTable(2, item, 1)
        }
        list.push(...this.form.organogram2.data)
      }
      return list
    }
  },
  methods: {
    comma (str) {
      return `${str}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    /**
     * convertTreeToTable: form.data 를 table 에 사용하는 data 로 변환한다.(453)
     */
    convertTreeToTable (index, item, lv) {
      item.lv = lv
      item.title = this.getTitle(index, lv)
      item.totalChildCount = this.totalChildCount(item)
      item.paddingLeft = 0;
      item.paddingRight = 0;

      if (item.child && item.child.length > 0) {
        for (const sub of item.child) {
          this.convertTreeToTable(index, sub, lv + 1)
        }
      }
    },

    totalChildCount (item) {
      if (!item.child || item.child.length === 0) {
        return 1
      } else {
        let count = 0;
        for (const sub of item.child) {
          count += this.totalChildCount(sub)
        }
        return count
      }
    },

    getTitle (index, lv) {
      const organizations = index === 1? this.form.organogram1.organizations : this.form.organogram2.organizations;
      for (const item of organizations) {
        if (item.lv === lv) {
          return item.name;
        }
      }
      return ''
    }
  }
}
</script>
<style lang="scss">
#print-1046 {
  .head-label {
    font-size: 36px;
    font-weight: 500;
    text-align: center;
  }
  .head-title {
    font-size: 40px;
    font-weight: 700;
    text-align: center;
  }
  .head-subtitle {
    font-size: 28px;
    font-weight: 700;
    text-align: start;
  }
  .content-normal {
    font-size: 26px;
    font-weight: 400;
    text-align: start;
  }
  .content-small {
    font-size: 20px;
    font-weight: 500;
    text-align: start;
  }
  .caption-top {
    font-size: 22px;
    font-weight: 400;
    text-align: center;
  }

  $border: 1px solid #cdcdcd;
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;

    th, td {
      border: solid #cdcdcd 1px;
      text-align: center;
      font-size: 18px;
      padding: 10px;
    }

    th {
      background: #FFF7E2;
      font-weight: 500;
    }

    td {
      font-weight: 400;
    }
  }

  .print-body {
    display: flex;
    justify-content: center;

  }
}
</style>
